import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useSelectedCampaign } from '../../../hooks/useSelectedCampaign';

export const useRecommendationsQueryKey = () => {
    const {
        campaign: { id: campaignId },
    } = useSelectedCampaign();
    const { accountId } = useAccount();
    return [accountId, campaignId, 'recommendations'];
};
